import { Sparkles, CheckCircle } from "lucide-react";
import { Glossary } from "../Glossary";
import { useLanguage } from "../../context/LanguageContext";
import { useHome } from "../../translations/home";
import { DemoForm } from "../DemoForm";

const HomeFinalCTA = () => {
  const { language } = useLanguage();
  const h = useHome(language);
  const f = h.final;

  return (
    <section
      id="demo-form"
      className="scroll-mt-20 bg-navy-900 py-20 lg:py-24 relative overflow-hidden"
      data-testid="demo-form-section"
    >
      <div className="absolute inset-0 dots-drift opacity-60 pointer-events-none" aria-hidden="true" />
      <div
        className="absolute inset-0 opacity-60 pointer-events-none"
        style={{ background: "radial-gradient(ellipse 60% 80% at 80% 0%, rgba(0,71,171,0.55), transparent 65%)" }}
        aria-hidden="true"
      />
      <Glossary><div className="wrap-cayus relative">
        <div className="grid lg:grid-cols-[1.05fr_1fr] gap-12 lg:gap-16 items-start">
          <div>
            <span
              className="inline-flex items-center gap-2 mono-cayus text-[#0A2342] bg-[#F59E0B] rounded-full px-3.5 py-1.5 mb-7"
              data-testid="scarcity-badge"
            >
              <Sparkles className="w-3.5 h-3.5" />
              {f.badge}
            </span>
            <h2 className="font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white tracking-[-0.03em] leading-[1.08] mb-6">
              {f.title}
            </h2>
            <p className="text-lg text-[#CFE6FC] leading-relaxed mb-8 max-w-[38rem]">{f.text}</p>
            <div className="flex items-start gap-3 text-[#9ECEFA]">
              <CheckCircle className="w-5 h-5 flex-shrink-0 mt-0.5" />
              <span className="text-sm">{h.cta.sub}</span>
            </div>
          </div>

          <div className="bg-white/[0.06] border border-white/15 rounded-2xl p-7 sm:p-8 backdrop-blur-sm">
            <DemoForm />
          </div>
        </div>
      </div></Glossary>
    </section>
  );
};

export default HomeFinalCTA;
